import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { updateProviderById } from '../../../api/cms/provider';

const REPORT_TYPES = [
  { value: 'bet', label: 'Bet' },
  { value: 'payout', label: 'Payout' },
];

const CUTOFFS = [
  { value: 'midnight', label: 'Midnight (00:00)' },
  { value: 'midday', label: 'Midday (12:00)' },
];

const ProviderReportConfig = ({ data, providerId }) => {
  const [form, setForm] = useState({ report_type: '', timezone: '', cutoff: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const config = data?.invoice_report_config;
    if (config) {
      setForm({
        report_type: config.report_type || '',
        timezone: config.timezone || '',
        cutoff: config.cutoff || '',
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateProviderById(providerId, {
        invoice_report_config: {
          report_type: form.report_type,
          timezone: form.timezone,
          cutoff: form.cutoff,
        },
      });
      toast.success('Report config updated');
    } catch (err) {
      toast.error(_.get(err, 'response.data.message', 'Failed to update report config'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom component="div">
        Report Config
      </Typography>
      <Box display="flex" flexDirection="column" style={{ gap: 16, maxWidth: 420 }}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Report Type</InputLabel>
          <Select
            name="report_type"
            value={form.report_type}
            onChange={handleChange}
            label="Report Type"
          >
            {REPORT_TYPES.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Timezone"
          name="timezone"
          value={form.timezone}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          placeholder="e.g. UTC, UTC+7, Asia/Bangkok"
          helperText="Timezone used to determine daily report boundaries"
        />

        <FormControl variant="outlined" fullWidth>
          <InputLabel>Daily Cutoff</InputLabel>
          <Select name="cutoff" value={form.cutoff} onChange={handleChange} label="Daily Cutoff">
            {CUTOFFS.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box>
          <Button variant="contained" color="primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

ProviderReportConfig.propTypes = {
  data: PropTypes.object,
  providerId: PropTypes.string.isRequired,
};

export default ProviderReportConfig;
